export type QuestionType =
  | 'single'
  | 'multiple'
  | 'matching'
  | 'sequence'
  | 'hotspot'
  | 'dragdrop'
  | 'calculation'
  | 'truefalse';

export type AnswerValue = string | string[] | number | Record<string, string | string[]> | null;

export interface Question {
  id: string;
  question_id: string;
  type: QuestionType | string;
  cognitive_type?: string;
  scenario_en: string;
  scenario_ar: string;
  options_en: string[];
  options_ar: string[];
  domain: string;
  difficulty: string;
  reference?: string;
  correct_answer: AnswerValue;
  explanation_en: string;
  explanation_ar: string;
  choice_explanations_en?: string[];
  choice_explanations_ar?: string[];
  // Matching: items in column A and column B
  match_items_a_en?: string[];
  match_items_a_ar?: string[];
  match_items_b_en?: string[];
  match_items_b_ar?: string[];
  // Sequence / ordering: items to order
  sequence_items_en?: string[];
  sequence_items_ar?: string[];
  // Drag-and-drop / categorization
  categories_en?: string[];
  categories_ar?: string[];
  dragdrop_items_en?: string[];
  dragdrop_items_ar?: string[];
  // Calculation: numeric precision hint
  calculation_tolerance?: number;
}

export function normalizeType(raw?: string | null): QuestionType {
  if (!raw) return 'single';
  const lower = String(raw).toLowerCase().trim();
  if (lower === 'mcq' || lower === 'single_choice' || lower === 'single' || lower === 'choose_one') return 'single';
  if (lower === 'multiple' || lower === 'multiple_response' || lower === 'multiple_choice' || lower === 'multi') return 'multiple';
  if (lower === 'matching' || lower === 'match') return 'matching';
  if (lower === 'sequence' || lower === 'ordering' || lower === 'order') return 'sequence';
  if (lower === 'hotspot' || lower === 'hot_area') return 'hotspot';
  if (lower === 'dragdrop' || lower === 'drag_drop' || lower === 'categorization' || lower === 'categorize' || lower === 'classification') return 'dragdrop';
  if (lower === 'calculation' || lower === 'calculated' || lower === 'fill_blank' || lower === 'fill_in') return 'calculation';
  if (lower === 'truefalse' || lower === 'true_false' || lower === 'true/false') return 'truefalse';
  return 'single';
}
